import React, { useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import ExportApi from "../../src/api/ExportApi";
import { toast } from "react-toastify";
import { useForm } from 'react-hook-form';
import EditorComponent from "../shared/editor";

  

export default function GlobalDescription() {
    const { register, handleSubmit, setValue, control, reset, formState: { errors }, } = useForm();

    const [count, setCount] = useState();
    const [isButtonDisabled, setButtonDisabled] = useState(false);
    const [description, setDescription] = useState(null);

    const fetchData = async () => {
        try {
            const res = await ExportApi.getProductDescriptions();
            const data = res?.data?.descriptions ?? ""
            setDescription(data);
        } catch (error) {
            console.error('Error fetching global description data:', error);
        }
    };
    const onSubmit = (data) => {
        const payload = {
            description : description ?? ""
        }
        setButtonDisabled(true);
        setCount(0)
        // const descriptionWithoutTags = description ? description.replace(/<\/?p>/g, '') : '';
        // data.description = descriptionWithoutTags;);
        ExportApi.updateGlobaldescription(payload)
            .then((resp) => {
                const data = resp?.data?.message;
                if (data) {
                    toast.success(data)
                    reset();
                    setCount(1)
                    setButtonDisabled(false);
                    fetchData();
                } else {
                    toast.error(data)
                    setCount(1)
                    setButtonDisabled(false);
                }
            }).catch((err) => console.log(err))
        setCount(1)
    };


    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            {count == 0 ?
                <div className="loader-icon" style={{ marginBlock: "80px" }}>
                    <i className="fa-solid fa-spinner fa-spin-pulse"></i>
                </div>
                :
                <Form onSubmit={handleSubmit(onSubmit)} className="py-5">
                    <h2 className="mb-4">Global Description</h2>
                    <Form.Group controlId="name" className="mb-4">
                        <EditorComponent editorContent={description} setEditorContent={setDescription}/>
                        {errors.name && <p className="form-error">{errors.name.message}</p>}
                    </Form.Group>
                    <Button variant="primary" type="submit" className="mt-5" disabled={isButtonDisabled}>
                        {isButtonDisabled ? 'Submitting...' : 'Submit'}
                    </Button>
                </Form>
            }

        </>

    );
}
